import Permissions from '@app/src/auth/permissions'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './LegacyMenuWrapper'
import { MenuLinkWrapper } from './LegacyMenuWrapper'
import type { NavbarItemProps } from './LegacyNavbarItems'

const CO2eCalculatorLink: React.FC<NavbarItemProps> = ({ closeMenuDrawer }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.co2eCalculator,
    permission: [Permissions.TRANSPARENCY_USER],
  }

  return (
    <MenuLinkWrapper
      closeMenuDrawer={closeMenuDrawer}
      external
      menuItems={menuItems}
      title={formatMessage({ id: 'navbar.co2eCalculator' })}
    />
  )
}

export default CO2eCalculatorLink
